import React from 'react';

import { LexOfficeBookingData } from '../../../types';
import { useBookingDataForm } from '../hooks/useBookingDataForm';

import BookingFormEditControls from './BookingFormEditControls';
import BookingFormFields from './BookingFormFields';
import BookingLineItemList from './BookingLineItemList';

interface BookingDataFormProps {
  bookingData: LexOfficeBookingData;
  onSave?: (updatedData: LexOfficeBookingData) => void;
  isEditing: boolean;
  onEditModeChange: (editing: boolean) => void;
  showValidation: boolean;
  hasChanges?: boolean;
  onRestore?: () => void;
}

const BookingDataForm: React.FC<BookingDataFormProps> = ({
  bookingData,
  onSave,
  isEditing,
  onEditModeChange,
  showValidation,
  hasChanges = false,
  onRestore,
}) => {
  const form = useBookingDataForm({
    bookingData,
    isEditing,
    onSave,
    onEditModeChange,
  });

  return (
    <div className='space-y-4 mt-4'>
      <BookingFormEditControls
        isEditing={isEditing}
        hasChanges={hasChanges}
        onEditModeChange={onEditModeChange}
        onSave={form.handleSave}
        onCancel={form.handleCancel}
        onRestore={onRestore}
        canEdit={!!onSave}
      />

      <BookingFormFields
        bookingData={form.displayData}
        isEditing={isEditing}
        onFieldChange={form.updateField}
      />

      {/* Line Items */}
      <div className='pt-4 border-gray-200'>
        <div className='mb-3'>
          <span className='text-sm font-medium text-gray-700'>Line Items:</span>
        </div>
        <BookingLineItemList
          items={form.displayData.voucherItems}
          isEditing={isEditing}
          currency={form.displayData.currency || 'EUR'}
          onUpdate={form.updateLineItem}
          onAdd={form.addLineItem}
          onRemove={form.removeLineItem}
          showValidation={showValidation}
        />
      </div>
    </div>
  );
};

export default BookingDataForm;
